import { useCallback } from 'react';
import { connect } from 'react-redux';

import { PopdownMenu } from './PopdownMenu.jsx';
import {
  addTileToDigest,
  showDigestCalendar,
  deleteDigest,
} from '../../lib/redux/actions.jsx';
import { renderDigestMenuButtons, digestDropdownToggle } from './utils';

const TileDigestPopDownMenu = props => {
  const onShow = useCallback(
    () => digestDropdownToggle(props.bucketDate, 'show'),
    [props.bucketDate],
  );

  const onHide = useCallback(
    () => digestDropdownToggle(props.bucketDate, 'hide'),
    [props.bucketDate],
  );

  return (
    <div id={`dropdown-${props.bucketDate}`}>
      <PopdownMenu
        style={{ marginLeft: '50px' }}
        dropdownId={props.bucketDate}
        afterShow={onShow}
        afterHide={onHide}
        menuProps={{
          className: 'tile-thumbnail-menu',
        }}
        menuElements={renderDigestMenuButtons(props)}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  createTile: bucketDate => dispatch(addTileToDigest(bucketDate)),
  editDigest: bucketDate => dispatch(showDigestCalendar(bucketDate)),
  deleteDigest: bucketDate => dispatch(deleteDigest(bucketDate)),
});

export { TileDigestPopDownMenu };

export default connect(null, mapDispatchToProps)(TileDigestPopDownMenu);
